exports.backgroundColor = "#FAFAFA";
exports.backgroundColorDarker = "#f8f8f8";

exports.colorRow = "#2a9bc2";


//Arak
// exports.colorPrimary = "#3F51B5";
// exports.colorPrimaryDark = "#303F9F";
// exports.colorSecondPrimary = "#ff3d00";


//Golpayegan
// exports.colorPrimary="#73a026";
// exports.colorPrimaryDark="#047d00";
// exports.colorSecondPrimary="#ff9c00";

//Bumehen
// exports.colorPrimary="#01379c";
// exports.colorPrimaryDark="#01387B";
// exports.colorSecondPrimary="#474647";

//Rafsanjan
// exports.colorPrimary="#1abc9c";
// exports.colorPrimaryDark="#18a386";
// exports.colorSecondPrimary="#d7b10d";

//Police
// exports.colorPrimary="#3F51B5";
// exports.colorPrimaryDark="#303F9F";
// exports.colorSecondPrimary="#ff3d00";

//Marvdasht
// exports.colorPrimary="#529F5F";
// exports.colorPrimaryDark="#499255";
// exports.colorSecondPrimary="#3700FF";

//125
// exports.colorPrimary="#FE273E";
// exports.colorPrimaryDark="#e8273a";
// exports.colorSecondPrimary="#9A0154";

//Satia
// exports.colorPrimary = "#e52427";
// exports.colorPrimaryDark = "#c82022";
// exports.colorSecondPrimary = "#df9122";

//Shahrban
exports.colorPrimary="#5D268D";
exports.colorPrimaryDark="#461e6d";
exports.colorSecondPrimary="#8BC34A";

//Shahrban jadid
// exports.colorPrimary="#3CDBF5";
// exports.colorPrimaryDark="#34c2db";
// exports.colorSecondPrimary="#9389FA";

//Ilam
// exports.colorPrimary="#00C5CA";
// exports.colorPrimaryDark="#00a5aa";
// exports.colorSecondPrimary="#ff3d00";

// Jahrom
// exports.colorPrimary="#F08800";
// exports.colorPrimaryDark="#da7700";
// exports.colorSecondPrimary="#16ba01";

//Kerman
// exports.colorPrimary="#34a503";
// exports.colorPrimaryDark="#318D03";
// exports.colorSecondPrimary="#536067";

//MahmoodAbad
// exports.colorPrimary = "#3F51B5";
// exports.colorPrimaryDark = "#303F9F";
// exports.colorSecondPrimary = "#ff3d00";


// exports.colorPrimary="#FF6021";
// exports.colorPrimaryDark="#df5719";
// exports.colorSecondPrimary="#061ACC";


//Borazjan
// exports.colorPrimary = "#193819";
//exports.colorPrimaryDark = "#184818";
// exports.colorSecondPrimary = "#967B2C";


//Roudan
// exports.colorPrimary = "#068C48";
// exports.colorPrimaryDark = "#135C36";
// exports.colorSecondPrimary = "#011F2F";

//Maraghe
// exports.colorPrimary = "#006e06";
// exports.colorPrimaryDark = "#004B06";
// exports.colorSecondPrimary = "#011F2F";

//Khorramshahr
// exports.colorPrimary = "#07095d";
// exports.colorPrimaryDark = "#07093A";
// exports.colorSecondPrimary = "#9a9b52";

//Bushehr
// exports.colorPrimary = "#018c3d";
// exports.colorPrimaryDark = "#016934";
// exports.colorSecondPrimary = "#766635";

//Gerash
// exports.colorPrimary = "#07095d";
// exports.colorPrimaryDark = "#07093A";
// exports.colorSecondPrimary = "#9a9b52";

//Behbahan
// exports.colorPrimary = "#564CA3";
// exports.colorPrimaryDark = "#3a3a75";
// exports.colorSecondPrimary = "#E1A233";

//Boumehen
// exports.colorPrimary = "#00A651";
// exports.colorPrimaryDark = "#008543";
// exports.colorSecondPrimary = "#E1A233";

//Shahrman
// exports.colorPrimary = "#1D84C7";
// exports.colorPrimaryDark = "#1461AB";
// exports.colorSecondPrimary = "#4f9640";

//Marvdasht
// exports.colorPrimary = "#1D84C7";
// exports.colorPrimaryDark = "#1461AB";
// exports.colorSecondPrimary = "#4f9640";

//Zarghan
// exports.colorPrimary = "#0CAE4D";
// exports.colorPrimaryDark = "#0c9144";
// exports.colorSecondPrimary = "#E1A233";


//Lavasan
// exports.colorPrimary = "#092391";
// exports.colorPrimaryDark = "#091f6b";
// exports.colorSecondPrimary = "#4f9640";

//Abadeh
// exports.colorPrimary = "#174C72";
// exports.colorPrimaryDark = "#153557";
// exports.colorSecondPrimary = "#4f9640";

//Cloud
// exports.colorPrimary = "#174C72";
// exports.colorPrimaryDark = "#153557";
// exports.colorSecondPrimary = "#4f9640";

//CloudTest
// exports.colorPrimary = "#174C72";
// exports.colorPrimaryDark = "#153557";
// exports.colorSecondPrimary = "#4f9640";

//*********** Fire ************////
//ChabaharFire
// exports.colorPrimary="#01379c";
// exports.colorPrimaryDark="#01387B";
// exports.colorSecondPrimary="#474647";

//FireArdabil
// exports.colorPrimary="#01379c";
// exports.colorPrimaryDark="#01387B";
// exports.colorSecondPrimary="#474647";

//*********** Mahalema ************////
//MahalemaArak
// exports.colorPrimary = "#4e6881";
// exports.colorPrimaryDark = "#374f68";
// exports.colorSecondPrimary = "#ff3d00";


exports.transparent = "transparent";

exports.yellow = "#ebbc00";
exports.yellowLight = "#fff3cd";
exports.light3 = "#fcfcfc";
exports.light2 = "#e5e5e5";
exports.light = "#eee";
exports.light43 = "#d4d4d4";
exports.graylight = "#d0d0d0";
exports.gray = "#A7A7A7";
exports.gray2 = "#a3a3a3";
exports.white = "#fff";
exports.colorDark = "#777";
exports.colorDarkText = "#474647";
exports.colorDarker = "#222";
exports.black = "#030303";
exports.blackLight = "#262626";
exports.green = "#22BEA3";
exports.blue = "#005bdd";
exports.red = "#BE223B";
exports.redLight = "#f02a4b";
exports.fire = "#FB5252";

exports.grayLight = "#F5F5F5";


exports.gray1 = "#c0c0c0";
exports.gray2 = "#cbcbcb";
exports.gray3 = "#d8d8d8";
exports.green1 = "#e6ffd1";
exports.ColorLine = "#E2E4FF";
exports.warning = "#f8d7da";


exports.primaryColor = '#213A77';
exports.secondaryColor = '#4A6CB4';
exports.readableBlack = '#2b2b2b';
exports.link = '#0099ff';

exports.help = "#e0f1ff";
exports.helpBorder = "#113960";
